<template>
	<div class="drawer">
		<el-drawer
		size="750px"
		title="订金订单"
		:visible.sync="drawerStatus"
		@close='handleClose'
		:append-to-body="true"
		>
			<el-table :data="list" style="width: 100%" @selection-change="handleSelectionChange" ref="table">
				<el-table-column v-if="type==='selected'" type="selection" width="55">
				</el-table-column>
				<el-table-column label="单号">
					<template slot-scope="scope">
						{{scope.row.no}}
					</template>
				</el-table-column>
				<el-table-column label="宠物">
					<template slot-scope="scope">
						{{scope.row.order_item_list[0].goods_name}}
					</template>
				</el-table-column>
				<el-table-column label="品种" width="100">
					<template slot-scope="scope">
						{{scope.row.order_item_list[0].category_info.name}}
					</template>
				</el-table-column>
				<el-table-column label="订金" width="60">
					<template slot-scope="scope">
						{{scope.row.total_price}}
					</template>
				</el-table-column>
				<el-table-column label="创建时间">
					<template slot-scope="scope">
						{{$public.FTime(scope.row.order_item_list[0].add_time)}}
					</template>
				</el-table-column>
				<el-table-column label="创建门店" width="80">
					<template slot-scope="scope">
						{{$public.getShopNameById(scope.row.company_info.shop_id)}}
					</template>
				</el-table-column>
			</el-table>
			<div v-if="type==='selected'" style="padding:20px 20px;">已选择订金：{{selectedMoney}} 元</div>
			<div style="height: 40px;width:100%;"></div>
			<div class="btnBox">
				<div class="btnItem" @click="handleClose">取消</div>
				<div class="btnItem submit" @click="submitCode">确定</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				
				list:[],
				
				selectedArr:[],
				selectedMoney:0,
			}
		},
		computed:{
			dingjinOrder(){
				return this.$store.state.mendian.dingjinOrder;
			},
			curShopInfo(){
				return this.$store.getters.curShopInfo;
			},
		},
		props:{
			type:{
				default:'see',
			},
			petId:{
				default:'',
			}
		},
		watch:{
		},
		mounted(){
			let list1 = []
			let list2 = []
			for(let i=0;i<this.dingjinOrder.length;i++){
				if(this.dingjinOrder[i].order_item_list[0].goods_id===this.petId){
					list1.push(this.dingjinOrder[i])
				}else{
					list2.push(this.dingjinOrder[i])
				}
			}
			this.list = list1.concat(list2)
			this.$nextTick(()=>{
				this.drawerStatus = true
				console.log(this.list)
				this.$nextTick(()=>{
					for(let i=0;i<this.list.length;i++){
						if(this.list[i].order_item_list[0].goods_id===this.petId){
							this.$refs.table.toggleRowSelection(this.list[i])
						}
					}
				})
			})
			
		},
		methods: {
			handleClose(){
				this.$emit('submit',{type:'close'})
			},
			submitCode(){
				this.$emit('submit',{type:'success',data:this.selectedArr})
			},
			handleSelectionChange(val){
				this.selectedArr = val;
				this.selectedMoney = 0;
				for(let i=0;i<val.length;i++){
					this.selectedMoney = this.$public.jia(this.selectedMoney,val[i].total_price)
				}
			},
			
		},
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.form{
				::v-deep .el-form-item{
					margin:5px 0;
				}
			}
		}
		
	}
	.btnBox{
		width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
		.btnItem{
			text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
			&.submit{
				background-color: $mainColor;
			}
		}
	}
</style>
